import { render, staticRenderFns } from "./TopSonIncidencesCard.vue?vue&type=template&id=c0db832e"
import script from "./TopSonIncidencesCard.vue?vue&type=script&lang=js"
export * from "./TopSonIncidencesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports